import React from 'react'
import { Platform, Text, View } from 'react-native'
import { useCssStyle } from '../../customHook/getCssStyle'
import CustomPressable from '../customPressable/customPressable';
import { ImageComp } from '../Image/Image';
import { useDispatch } from 'react-redux';
import { setShowBookmarkPopup } from '../../Redux/Reducers/appConfigReducer';
import { EXPORT, STAR } from '../../assets';

const BookmarkPopup = () => {
    const getStyles = useCssStyle();
    const dispatch = useDispatch();
    
    const handleAddBookmarkWeb = () => {
        if (
            Platform.OS === 'web' && typeof window !== 'undefined' && window.external && window.external.AddFavourite
        ) {
            window.external.AddFavourite(window.location.href, document.title);
        }
    };

    const renderMobile = () => {
        if (Platform.OS === 'ios') {
            return (
                <Text id="bookmarkPopupText" style={getStyles(["bookmarkPopupText"])}> Tip: Tap <ImageComp style={{ width: 20, borderRadius: 5 }} source={EXPORT} /> then “Add to Home Screen”.</Text>
            );
        }

        if (Platform.OS === 'android') {
            return (
                <Text id="bookmarkPopupText" style={getStyles(["bookmarkPopupText"])}>
                    Tip: Use your browser menu to add this page to your home screen.
                </Text>
            );
        }

        return null;
    };


    const renderTablet = () => {
        return <Text id="bookmarkPopupText" style={getStyles(["bookmarkPopupText"])}>Tip: Press <ImageComp style={{width:"20px"}} source={STAR} /> next to the address bar to add this page to your bookmarks.</Text>;
    }

    const renderWebDesktop = () => {
        let commandKey = 'Ctrl';
        if (typeof navigator !== 'undefined' && navigator.platform?.includes('Mac')) {
            commandKey = 'Command (⌘)';
        }

        return (
        <>
            {typeof window !== 'undefined' &&
            window.external &&
                window.external.AddFavourite ? (
                    <CustomPressable onPress={handleAddBookmarkWeb}>
                        <Text id="bookmarkPopupText" style={getStyles(["bookmarkPopupText"])}>Click here to add this page to your bookmarks</Text>
                    </CustomPressable>
                ) : (
                    <Text id="bookmarkPopupText" style={getStyles(["bookmarkPopupText"])}>Tip: Press {commandKey} + D to bookmark this page.</Text>
                )}
        </>
        );
    };

    const renderContent = () => {
        // if (Platform.OS === 'web') {
        //     return renderWebDesktop();
        // }

        // if (Platform.isPad) {
        //     return renderTablet();
        // }

        // return renderMobile();
    };
    if(Platform.OS !== 'web') return null;

    return (
        <View style={getStyles(["bookmarkRootContainer"])} id='bookmarkRootContainer'>
            <View style={getStyles(["bookmarkTextContainer"])} id='bookmarkTextContainer'>
                <CustomPressable id="bookmarkTextCloseContainer" style={getStyles(["bookmarkTextCloseContainer", ])} onPress={() => { console.log("Called") ;dispatch(setShowBookmarkPopup(false))}}>
                    <Text id="bookmarkTextCloseText" style={getStyles(["bookmarkTextCloseText"])}>x</Text>
                </CustomPressable>

                {renderWebDesktop()}
            </View>
        </View>
    )
}

export default BookmarkPopup
